// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__VRunF","title":"Section_title__1cxRl"};